import { render, staticRenderFns } from "./ModalShowGalleryQuestion.vue?vue&type=template&id=a829e7fa"
import script from "./ModalShowGalleryQuestion.vue?vue&type=script&lang=js"
export * from "./ModalShowGalleryQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalShowGalleryQuestion.vue?vue&type=style&index=0&id=a829e7fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports